module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "image/Chap_2_sml_fmt.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Two")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Full-Out"
  }, [_c('span', {
    staticClass: "Drop-Cap-Style char-style-override-1",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("L")]), _vm._v("ife had been so different, three short months ago, back on the plains …")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("‘Concentrate on your work, Micah,’ Caleb bellowed, ‘or you’ll feel my whip on your back!’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("Micah lowered his head and gripped the parallel staves as tight as his blistered fingers would allow, and as the ox plodded forward, he endeavoured to keep the heavy plough moving as even as he could. He watched the blade bite into the hard ground, and the black earth fold over onto itself as he continued the line.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("He looked up and stared into the hazy distance once more; over the fields, through the shimmering heat of the dusty plains, and away towards the far-off horizon.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("Somewhere beyond the flat featureless plains lay the mountains of the high country – a land of impossibly high crags and deep verdant valleys, of thundering waterfalls and crystal-clear lakes; a land of bitter cold winters and furnace-hot summers, of driving rain and great swirling duststorms; of precious metals and priceless gemstones. And of wyrmes.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("Micah’s eyes lit up. Wyrmes!")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("He had never seen one, not down here on the plains, though he’d heard stories enough. Many left for the high country, and though few ever returned, those who did brought riches back with them – returner’s wealth – and the stories of the strange and terrifying creatures they’d encountered there … ")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("‘Micah!’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("Micah flinched as the voice bellowed in his ear, and the heavy open hand that followed struck him so hard on the side of his head that he was knocked away from the plough and ended up sprawling over the fresh-turned mud. He looked up.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("‘Didn’t I warn you?’ his brother Caleb demanded. His face was flushed red; his neck, cabled. ‘Didn’t I tell you to drive a straight line?’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("Micah swallowed, and nodded. ‘You did,’ he said meekly.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("‘And this is what you give me,’ Caleb roared, his hand wiggling like a swimming fish as he indicated the furrow Micah had ploughed. ‘I ain’t going to have you holding me back, boy. Y’understand me. The master has charged me with getting the fields ploughed good.’ He nodded ahead. ‘And this is "), _c('span', {
    staticClass: "Text-italic char-style-override-2",
    attrs: {
      "xml:lang": "en-CA"
    }
  }, [_vm._v("not")]), _vm._v(" good.’ He aimed a muddy boot at Micah’s chest. ‘Too busy daydreaming ’bout the master’s daughter, I’ll wager,’ he said, and sneered. ‘I swear, one smile from her and you’re as lovesick as a stable donkey, and about as useless!’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("Caleb grabbed Micah by the hair and hauled him roughly to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("‘Now get on with your work!’")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("Micah stepped between the curved staves of the plough once more and gripped them with renewed determination. The ox turned and surveyed him with doleful brown eyes. Micah twitched the reins and the ox turned away and trudged on.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("This time he was careful to keep his gaze on the line between the creature’s swaying rump and stout horns, and to ensure that the furrow he cut maintained the same line. He tried to empty his mind – to concentrate on his ploughing.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Indent"
  }, [_vm._v("But it was no good. Thanks to Caleb, Micah’s thoughts were now full of the master’s daughter, Seraphita.")]), _vm._v(" "), _c('p', {
    staticClass: "Ornament"
  }, [_c('span', [_c('img', {
    staticClass: "frame-4",
    attrs: {
      "alt": "TITLE%20PAGE.tif",
      "src": "image/TITLEPAGE_fmt3.png"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18727a15","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnersWealth_revised3.vue
// module id = 72
// module chunks = 0